import type { StartSource, StopReason } from './watch';
import type { WatchLike } from './watch-types';

/**
 * Stands in for Watch until `watch.js` has arrived. Not playing, so the player behaves as
 * click-through; a request to start or seek is remembered and `load` is asked for the real class,
 * which then gets the request replayed (`replay`).
 */
export class WatchStub implements WatchLike {
  playing = false;
  readonly took = new Map<string, number>();
  private pending:
    | { kind: 'start'; source: StartSource; offsetMs: number }
    | { kind: 'seek'; offsetMs: number; before: () => void }
    | null = null;

  constructor(private readonly load: () => void) {}

  start(source: StartSource, offsetMs = 0): void {
    this.pending = { kind: 'start', source, offsetMs };
    this.load();
  }

  seek(offsetMs: number, before: () => void): void {
    this.pending = { kind: 'seek', offsetMs, before };
    this.load();
  }

  /** Pause or any takeover before Watch arrived: the request is withdrawn. */
  stop(_reason: StopReason): void {
    this.pending = null;
  }

  position(): null {
    return null;
  }
  cameraPan(): void {}
  point(): void {}
  resync(): boolean {
    return false;
  }
  destroy(): void {
    this.pending = null;
  }

  replay(real: WatchLike): void {
    const p = this.pending;
    this.pending = null;
    if (!p) return;
    if (p.kind === 'start') real.start(p.source, p.offsetMs);
    else real.seek(p.offsetMs, p.before);
  }
}
